import { useConfiguration } from '~/context/common/StaticContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

type OEMPackages = { name: string; options: string[] };

export type OEMDataItem = { title: string; data: OEMPackages[] };

export default function useGetPoseOEMData() {
  const {
    installedPackages = [],
    isOEMFirstVehicle = false,
    installedOptions = [],
    standardEquipment = []
  } = useGetVehicleDetails();
  const { useCatalogOEMData = false } = useConfiguration();

  const hasInstalledPackages = installedPackages.length > 0;
  const hasInstalledOptions = installedOptions.length > 0;
  const hasStandardEquipment = standardEquipment.length > 0;
  const hasData =
    hasInstalledPackages || hasInstalledOptions || hasStandardEquipment;
  const showPoseOEMData = useCatalogOEMData
    ? !isOEMFirstVehicle && hasData
    : hasData;

  const maybeOEMData: Array<OEMDataItem | null> = [
    hasInstalledPackages
      ? {
          title: 'Installed packages',
          data: installedPackages.map(pack => ({
            name: pack.name,
            options: pack.options
          }))
        }
      : null,
    hasInstalledOptions
      ? {
          title: 'Installed options',
          data: [
            { name: '', options: installedOptions.map(option => option.name) }
          ]
        }
      : null,
    hasStandardEquipment
      ? {
          title: 'Standard equipment',
          data: [{ name: '', options: [...standardEquipment] }]
        }
      : null
  ];

  return {
    showPoseOEMData,
    poseOEMData: maybeOEMData.filter((data): data is OEMDataItem =>
      Boolean(data)
    )
  };
}
